unit LoginType;
{

/* Initial. */

}
interface

uses
  JS;

type
  TLoginType = class
  private
    fLoginkey: String;
    fUserName: String;
    fUserFunction: String;
    fDatetime: String;
    fActive: Boolean;
    fLastAction: String;
    fLastActionDateTime: String;
    fLastSystemAction: String;
    fLastSystemActionDateTime: String;
  public
    property LoginKey: String read fLoginkey;
    property UserName: String read fUserName;
    property UserFunction: String read fUserFunction;
    property DateTime: String read fDatetime;
    property Active: Boolean read fActive;
    property LastAction: String read fLastAction;
    property LastActionDateTime: String read fLastActionDateTime;
    property LastSystemAction: String read fLastSystemAction;
    property LastSystemActionDateTime: String read fLastSystemActionDateTime;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TLoginType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fLoginkey := String(JSObject_Type['loginKey']);
    fUserName := String(JSObject_Type['userName']);
    fUserFunction := String(JSObject_Type['userFunction']);
    fDatetime := String(JSObject_Type['dateTime']);
    fActive := (String(JSObject_Type['active']) = 'true');
    fLastAction := String(JSObject_Type['lastAction']);
    fLastActionDateTime := String(JSObject_Type['lastActionDateTime']);
    fLastSystemAction := String(JSObject_Type['lastSystemAction']);
    fLastSystemActionDateTime := String(JSObject_Type['lastSystemActionDateTime']);
  end;
end;

end.
